/**
 * Per-page 新手導覽「已看過」追蹤（localStorage）。
 * 以 route pathname 為 key，走完或跳過後標記，之後同頁不再自動彈出。
 *
 * 測試提示：在 console 執行 `localStorage.removeItem('intellio-tours-seen')`
 * 即可重置全部導覽，重新觸發。
 */
const KEY = 'intellio-tours-seen';

function read(): Record<string, boolean> {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}');
  } catch {
    return {};
  }
}

export function isTourSeen(pageKey: string): boolean {
  return !!read()[pageKey];
}

export function markTourSeen(pageKey: string): void {
  const data = read();
  data[pageKey] = true;
  localStorage.setItem(KEY, JSON.stringify(data));
}
